export default "__VITE_ASSET__4d308567__"